import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import UserIcon from "../../../assets/images/SignupImg/UserIcon.svg";
import PhoneIcon from "../../../assets/images/SignupImg/PhoneIcon.svg";
import WebIcon from "../../../assets/images/SignupImg/CountryIcon.svg";
import EmailIcon from "../../../assets/images/SignupImg/Email.svg";
import LockIcon from "../../../assets/images/SignupImg/Password.svg";
import EyeIcon from "../../../assets/icons/eye.svg";
import EyeSlashedIcon from "../../../assets/icons/eye-slashed.svg";
import CheckSolidGreenIcon from "../../../assets/icons/check-solid-green.svg";
import CaretDownIcon from "../../../assets/icons/caret-down.svg";
import GoogleIcon from "../../../assets/images/SignupImg/Google.svg";

import { useNavigate } from "react-router-dom";
import { country } from "../../../utilities/country";

import { useDispatch } from "react-redux";
import { axiosInstance } from "../../../Axios";

import { AcctokenD, login, logout, RefftokenD } from "../../../store/actions";

import {
  getUserProfile,
  pushLead,
} from "../../../store/reducers/userProfileReducer";
import Spinner from "../../../reusableComponents/Spinner";
import { setExpiry } from "../../../store/reducers/tokenReducer";
import { BANNED_COUNTRY_CODES } from "../../../constants/bannedCountries";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { CalendarOutlined } from "@ant-design/icons";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function SignupForm({
  referalCode,
  setPopUpType,
  setShowPopup,
  setCombinedPUHead,
  setCombinedPUBody,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formData = new FormData();

  const countryOptions = country;
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isDropdown, setIsDropdown] = useState(false);
  const [options, setOptions] = useState(countryOptions);
  const [countryCode, setCountryCode] = useState("");
  const [isCountrySelected, setIsCountrySelected] = useState("");

  useEffect(() => {
    if (referalCode) {
      dispatch(pushLead(referalCode));
    }
  }, [referalCode, dispatch]);

  const initialValues = {
    first_name: "",
    last_name: "",
    date_of_birth: "",
    phone: "",
    email: "",
    confirmEmail: "",
    country: "United Kingdom",
    City: "",
    password: "",
    referal_code: referalCode || "",
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const filteredOptions = countryOptions.filter((item) =>
        item.country.toLowerCase().includes(value.toLowerCase())
      );
      setOptions(filteredOptions);
      setIsDropdown(true);
      setIsCountrySelected(value);
    }

    formData.set(name, value);
  };

  const handleDropdownChange = (value) => {
    setIsCountrySelected(value.country);
    setCountryCode(value.code);
    setIsDropdown(false);
    formData.set("country", value.country);
    formData.set("country_code", value.code);
  };

  // Add click outside handler to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isDropdown &&
        !event.target.closest(".signupform-container_dropdown")
      ) {
        setIsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdown]);

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log(values, "initialValuesinitialValues");
    setLoading(true);

    // Set form data for submission
    for (const [key, value] of Object.entries(values)) {
      formData.set(key, value);
    }

    // Set full name by combining first and last name
    formData.set("full_name", `${values.first_name} ${values.last_name}`);
    formData.set("country_code", Number(String(countryCode).replace("-", "")));

    try {
      const response = await axiosInstance.post("v2/email/signup/", formData);

      if (response.data.error) {
        setLoading(false);
        setPopUpType("error");
        setShowPopup(true);
        setCombinedPUHead("Oh snap!");
        setCombinedPUBody("Failed to Signup");
        dispatch(AcctokenD(0));
        dispatch(RefftokenD(0));
        dispatch(logout());
        return;
      }

      setLoading(false);

      // Set tokens and login
      dispatch(AcctokenD(response.data.firebase_cred.idToken));
      dispatch(RefftokenD(response.data.firebase_cred.refreshToken));

      const expiresInSeconds = 86400;
      const expiresAtDate = new Date();
      expiresAtDate.setSeconds(expiresInSeconds);
      dispatch(setExpiry(expiresAtDate));
      dispatch(login());

      // Get user profile and navigate
      const userProfile = await dispatch(getUserProfile());

      if (
        Array.isArray(userProfile.accounts) &&
        userProfile.accounts.length === 0
      ) {
        navigate("/FundingEvaluationPayment/89");
      } else if (
        Array.isArray(userProfile.accounts) &&
        userProfile.accounts.length > 0
      ) {
        navigate("/AccountMetric");
      } else {
        navigate("/FundingEvaluationPayment/89");
      }
    } catch (error) {
      setLoading(false);
      setErrorModal(true);

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        // Handle specific EMAIL_EXISTS error
        console.log(errorData.detail, "errorData.detailerrorData.detail");
        if (errorData.detail === "EMAIL_EXISTS") {
          setErrorMessage(
            "This email address is already registered. Please use a different email or try logging in."
          );
        } else {
          // Handle other error cases
          const firstKey = Object.keys(errorData)[0];
          const firstErrorMessage = errorData[firstKey]?.[0];

          setErrorMessage(
            errorData.detail ||
              firstErrorMessage ||
              "An error occurred during signup"
          );
        }
      } else {
        setErrorMessage("An error occurred during signup");
      }

      setPopUpType("error");
      setShowPopup(true);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody(
        error.response?.data?.detail === "EMAIL_EXISTS"
          ? "Email Already Exists"
          : error.response?.data?.message || "Failed to sign up"
      );

      dispatch(AcctokenD(0));
      dispatch(RefftokenD(0));
      dispatch(logout());
    }

    setSubmitting(false);
  };

  const handleGoogleAuth = () => {
    window.location.href =
      "https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.email&include_granted_scopes=true&response_type=code&state=pass-through value&redirect_uri=https://app.alphacapitalgroup.uk/auth/google&client_id=402277231112-imkppquf33eo2ap9btus3lr7m74okdvh.apps.googleusercontent.com";
  };

  useEffect(() => {
    // Prevent copy, cut, paste, and context menu
    const preventDefault = (e) => e.preventDefault();

    document.addEventListener("copy", preventDefault);
    document.addEventListener("cut", preventDefault);
    document.addEventListener("paste", preventDefault);
    document.addEventListener("contextmenu", preventDefault);

    return () => {
      document.removeEventListener("copy", preventDefault);
      document.removeEventListener("cut", preventDefault);
      document.removeEventListener("paste", preventDefault);
      document.removeEventListener("contextmenu", preventDefault);
    };
  }, []);

  // Validation schema
  const validationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(2, "First Name must be at least 2 characters!")
      .required("Please enter your first name!")
      .matches(/^[a-zA-Z\s]*$/, "First name can only contain letters"),
    last_name: Yup.string()
      .min(2, "Last Name must be at least 2 characters!")
      .required("Please enter your last name!")
      .matches(/^[a-zA-Z\s]*$/, "Last name can only contain letters"),
    date_of_birth: Yup.string()
      .required("Please select your date of birth!")
      .test(
        "is-past-date",
        "Date of birth cannot be in the future",
        (value) => {
          if (!value) return false;
          return dayjs(value).isBefore(dayjs(), "day");
        }
      ),
    phone: Yup.string()
      .required("Please enter your phone number!")
      .matches(/^\d+$/, "Phone number can only contain digits")
      .max(15, "Phone number cannot exceed 15 digits"),
    email: Yup.string()
      .required("Please enter your email!")
      .email("Please enter a valid email address"),
    confirmEmail: Yup.string()
      .required("Please confirm your email!")
      .email("Please enter a valid email address")
      .oneOf([Yup.ref("email")], "Email addresses don't match!"),
    country: Yup.string()
      .required("Please select a valid country!")
      .test(
        "valid-country",
        "Please select a valid country from the list",
        (value) => {
          if (!value) return false;
          return countryOptions.some((country) => country.country === value);
        }
      ),
    City: Yup.string().required("Please enter your city!"),
    password: Yup.string()
      .required("Please enter a password!")
      .min(8, "Password must be at least 8 characters!"),
    referal_code: Yup.string(),
  });

  return (
    <div className="signupform-container">
      {errorModal && (
        <ErrorModal
          desc={errorMessage}
          setModalOpen={setErrorModal}
          btnText="Cancel"
        />
      )}

      <div className="signupform-subcontainer">
        <div className="signupform-top-banner">
          <h2 className="signupform-title">Sign Up</h2>
          <p className="signupform-subtitle">
            Start your new journey! Please enter your Details
          </p>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form className="signupform-innercontainer signupform-container_form">
              <div className="signupform-subcontainer_form">
                <div
                  className="signupform-firstname-container"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={UserIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="first_name">
                      First Name
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type="text"
                        name="first_name"
                        id="first_name"
                        placeholder="First Name"
                        className={`signupform-input ${
                          errors.first_name && touched.first_name
                            ? "input-error"
                            : ""
                        }`}
                      />
                    </div>
                  </div>
                  {errors.first_name && touched.first_name && (
                    <p className="error-message">{errors.first_name}</p>
                  )}
                </div>

                <div className="signupform-lastname-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={UserIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="last_name">
                      Last Name
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type="text"
                        name="last_name"
                        id="last_name"
                        className={`signupform-input ${
                          errors.last_name && touched.last_name
                            ? "input-error"
                            : ""
                        }`}
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
                  {errors.last_name && touched.last_name && (
                    <p className="error-message">{errors.last_name}</p>
                  )}
                </div>
              </div>

              <div className="signupform-subcontainer_form">
                <div className="signupform-dob-container">
                  <DatePicker
                    value={
                      values.date_of_birth
                        ? dayjs(values.date_of_birth, "YYYY-MM-DD")
                        : null
                    }
                    format="YYYY-MM-DD"
                    placeholder="Select your Date of Birth"
                    className={`custom-datepicker ${
                      errors.date_of_birth && touched.date_of_birth
                        ? "input-error"
                        : ""
                    }`}
                    onChange={(date, dateString) => {
                      setFieldValue("date_of_birth", dateString);
                    }}
                    disabledDate={(current) =>
                      current && current.isAfter(dayjs(), "day")
                    }
                    suffixIcon={<CalendarOutlined className="calendar-icon" />}
                    style={{
                      height: 50,
                      width: "100%",
                      fontSize: 16,
                    }}
                    popupClassName="custom-calendar-popup"
                  />
                </div>
                {errors.date_of_birth && touched.date_of_birth && (
                  <p className="error-message">{errors.date_of_birth}</p>
                )}
              </div>

              <div className="signupform-subcontainer_form">
                <div className="signupform-contact-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={PhoneIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="phone">
                      Contact Number
                    </label>
                    <div className="signupform-container_input">
                      <div>
                        <span className="country_code">+{countryCode}</span>
                        <Field
                          type="text"
                          name="phone"
                          id="phone"
                          className={`signupform-input ${
                            errors.phone && touched.phone ? "input-error" : ""
                          }`}
                          placeholder="Contact Number"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.phone && touched.phone && (
                    <p className="error-message">{errors.phone}</p>
                  )}
                </div>
              </div>

              <div className="signupform-subcontainer_form">
                <div className="signupform-email-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={EmailIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="email">
                      Email
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type="email"
                        name="email"
                        id="email"
                        autoComplete="off"
                        className={`signupform-input ${
                          errors.email && touched.email ? "input-error" : ""
                        }`}
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="signupform-container_icon">
                      {values.email && !errors.email && (
                        <img
                          src={CheckSolidGreenIcon}
                          alt=""
                          className="signupform-icon"
                        />
                      )}
                    </div>
                  </div>
                  {errors.email && touched.email && (
                    <p className="error-message">{errors.email}</p>
                  )}
                </div>
              </div>

              <div className="signupform-subcontainer_form">
                <div className="signupform-email-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={EmailIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="confirmEmail">
                      Confirm Email
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type="email"
                        name="confirmEmail"
                        id="confirmEmail"
                        autoComplete="off"
                        className={`signupform-input ${
                          errors.confirmEmail && touched.confirmEmail
                            ? "input-error"
                            : ""
                        }`}
                        placeholder="Confirm Email Address"
                      />
                    </div>
                    <div className="signupform-container_icon">
                      {values.confirmEmail && !errors.confirmEmail && (
                        <img
                          src={CheckSolidGreenIcon}
                          alt=""
                          className="signupform-icon"
                        />
                      )}
                    </div>
                  </div>
                  {errors.confirmEmail && touched.confirmEmail && (
                    <p className="error-message">{errors.confirmEmail}</p>
                  )}
                </div>
              </div>

              <div className="signupform-container_dropdown">
                <div className="signupform-couuntry-container">
                  <div className="signupform-subcontainer_form">
                    <div className="signupform-innercontainer_form">
                      <div className="signupform-container_icon">
                        <img src={WebIcon} alt="" className="signupform-icon" />
                      </div>
                      <label className="signupform-label" htmlFor="country">
                        Country
                      </label>
                      <div className="signupform-container_input">
                        <Select
                          id="country"
                          name="country"
                          options={options.map((item) => ({
                            value: item.country,
                            label: item.country,
                            code: item.code,
                            iso: item.iso,
                          }))}
                          value={
                            isCountrySelected
                              ? { value: isCountrySelected, label: isCountrySelected }
                              : null
                          }
                          onChange={(selectedOption) => {
                            handleDropdownChange({
                              country: selectedOption.value,
                              code: selectedOption.code,
                              iso: selectedOption.iso,
                            });
                            setFieldValue("country", selectedOption.value);
                          }}
                          placeholder="Select Country"
                          className={`react-select-container ${
                            errors.country && touched.country ? "input-error" : ""
                          }`}
                          classNamePrefix="react-select"
                        />
                      </div>
                    </div>
                  </div>
                  {errors.country && touched.country && (
                    <p className="error-message">{errors.country}</p>
                  )}
                </div>
              </div>

              <div className="signupform-subcontainer_form">
                <div className="signupform-lastname-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={UserIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="City">
                      City
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type="text"
                        name="City"
                        id="City"
                        className={`signupform-input ${
                          errors.City && touched.City ? "input-error" : ""
                        }`}
                        placeholder="City"
                      />
                    </div>
                  </div>
                  {errors.City && touched.City && (
                    <p className="error-message">{errors.City}</p>
                  )}
                </div>
              </div>

              {values.referal_code && (
                <div className="signupform-subcontainer_form">
                  <div className="signupform-contact-container">
                    <div className="signupform-innercontainer_form">
                      <div className="signupform-container_icon">
                        <img
                          src={UserIcon}
                          alt=""
                          className="signupform-icon"
                        />
                      </div>
                      <label
                        className="signupform-label"
                        htmlFor="referal_code"
                      >
                        Referral Code
                      </label>
                      <div className="signupform-container_input">
                        <div>
                          <Field
                            type="text"
                            name="referal_code"
                            id="referal_code"
                            className="signupform-input"
                            placeholder="Referral Code"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="signupform-subcontainer_form">
                <div className="signupform-password-container">
                  <div className="signupform-innercontainer_form">
                    <div className="signupform-container_icon">
                      <img src={LockIcon} alt="" className="signupform-icon" />
                    </div>
                    <label className="signupform-label" htmlFor="password">
                      Password
                    </label>
                    <div className="signupform-container_input">
                      <Field
                        type={isPasswordVisible ? "text" : "password"}
                        name="password"
                        id="password"
                        className={`signupform-input ${
                          errors.password && touched.password
                            ? "input-error"
                            : ""
                        }`}
                        placeholder="Password"
                      />
                    </div>
                    <div className="signupform-container_icon">
                      <img
                        src={isPasswordVisible ? EyeIcon : EyeSlashedIcon}
                        alt=""
                        className="signupform-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsPasswordVisible((prev) => !prev)}
                      />
                    </div>
                  </div>
                  {errors.password && touched.password && (
                    <p className="error-message">{errors.password}</p>
                  )}
                </div>
              </div>

              <div className="signup_bottom">
                <div className="signupform-container_button">
                  <button
                    type="submit"
                    className="signupform-button"
                    disabled={loading}
                  >
                    {loading ? <Spinner /> : "Sign Up"}
                  </button>
                </div>
                <div
                  className="signup_with_google"
                  onClick={handleGoogleAuth}
                  style={{ cursor: "pointer" }}
                >
                  <p className="signinform-continue">Or sign up using</p>
                  <div className="signinform-innercontainer signinform-container_icon">
                    <div className="signinform-subcontainer_icon">
                      <img
                        style={{ cursor: "pointer" }}
                        src={GoogleIcon}
                        alt="google logo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default SignupForm;
